<template>
    <v-container fluid no-gutters class="mx-0 px-0 py-0 my-0">
        <v-row no-gutters>
            <v-col xl=12 lg=12 md=12 sm=12 xs=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
                <v-img
                    height="auto"
                    width="100vw"
                    contain 
                    :src="require('@/assets/main1.jpg')">
                </v-img>
            </v-col>
        </v-row>
        <section class="login">
            <div class="login__card">
                <h1 class="login__title">Είσοδος</h1>
                <p class="login__lead">Επιλέξτε πώς θέλετε να συνδεθείτε</p>
                <div class="login__types" role="tablist">
                    <button
                        v-for="choice in choices"
                        :key="choice.value"
                        type="button"
                        role="tab"
                        class="login__type"
                        :class="{ 'login__type--active': type === choice.value }"
                        :aria-selected="type === choice.value"
                        @click="type = choice.value"
                    >
                        <v-icon small>{{ choice.icon }}</v-icon>
                        {{ choice.value }}
                    </button>
                </div>
                <div class="login__form">
                    <card-check v-if="type === 'Μέλος'"/>
                    <login-form v-else/>
                </div>
                <div class="login__register">
                    Δεν έχετε λογαριασμό;
                    <router-link to="/Register">Κάντε εγγραφή</router-link>
                </div>
            </div>
        </section>
    </v-container>
</template>

<script>
    import CardCheck from '@/components/CardCheck'
    import LoginForm from '@/components/LoginForm'
    export default {
        components: { CardCheck, LoginForm },
        data: () => ({
            type: 'Μέλος',
            choices: [
                { value: 'Μέλος', icon: 'mdi-card-account-details-outline' },
                { value: 'Σωματείο', icon: 'mdi-account-group-outline' },
                { value: 'Συνεργάτης', icon: 'mdi-storefront-outline' }
            ]
        })
    }
</script>


<style scoped>
.login {
    padding: 0 18px 64px;
    background: linear-gradient(180deg, #f2f4f8 0%, #fff 100%);
}

.login__card {
    position: relative;
    max-width: 620px;
    margin: -56px auto 0;
    padding: 36px 40px 28px;
    background: #fff;
    border: 1px solid rgba(27, 47, 90, 0.1);
    border-radius: 18px;
    box-shadow: 0 16px 40px rgba(27, 47, 90, 0.14);
    color: #1b2f5a;
    text-align: center;
}

.login__title {
    font-size: 28px;
    font-weight: 700;
}

.login__lead {
    margin: 4px 0 20px;
    font-size: 15px;
    color: rgba(27, 47, 90, 0.7);
}

.login__types {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
    padding: 4px;
    border-radius: 12px;
    background: #f2f4f8;
}

.login__type {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 8px;
    border-radius: 9px;
    color: #1b2f5a;
    font-size: 15px;
    font-weight: 600;
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.login__type .v-icon {
    color: inherit;
}

.login__type:hover {
    background: rgba(255, 255, 255, 0.6);
}

.login__type--active,
.login__type--active:hover {
    background: #fff;
    color: #ad282d;
    box-shadow: 0 1px 4px rgba(27, 47, 90, 0.16);
}

.login__form {
    margin-top: 20px;
    font-size: 15px;
}

.login__register {
    margin-top: 16px;
    padding-top: 18px;
    border-top: 1px solid rgba(27, 47, 90, 0.1);
    font-size: 15px;
}

.login__register a {
    color: #ad282d;
    font-weight: 700;
}

@media (max-width: 599px) {
    .login__card {
        margin-top: -24px;
        padding: 24px 16px 20px;
    }

    .login__type {
        flex-direction: column;
        gap: 2px;
        font-size: 13px;
    }
}
</style>